import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { InfrastructuresLandingPage } from './infrastructures-landing-page/infrastructures-landing-page';
import { SharedModule } from '../../shared/shared.module';
import { IsavCommonModule } from '../../common/common.module';
import { InfrastructureMarkerColorPipe } from './infrastructures-search-page/infrastructure-marker-color';
import { InfrastructuresSearchPage } from './infrastructures-search-page/infrastructures-search-page';
import { SearchModule } from '../../core/search/search.module';
import { InfrastructuresResourceService } from '../../core/api/infrastructures-resource.service';
import { InfrastructuresViewPage } from './infrastructures-view-page/infrastructures-view-page';
import { InfrastructuresEditPage } from './infrastructures-edit-page/infrastructures-edit-page';
import { IriWithSearchFallbackGuard } from '../../core/auth/iri-with-search-fallback.guard';
import { IriResolver } from '../../core/api/iri.resolver';
import { InfrastructuresForm } from './infrastructures-form/infrastructures-form';
import { AuthenticatedGuard } from '../../core/auth/authenticated.guard';
import { ContentEditGuard } from '../../core/auth/content-edit.guard';
import { ContentCreateGuard } from '../../core/auth/content-create.guard';
import { InfrastructuresSarView } from './infrastructures-sar-view/infrastructures-sar-view';
import { CanDeactivateChangesWarning } from '../../core/changes-warning/can-deactivate-changes-warning.service';
import { ChangesWarningSharedModule } from '../../core/changes-warning/changes-warning-shared.module';

const ROUTES: Routes = [
    { path: '', pathMatch: 'full', component: InfrastructuresLandingPage },
    { path: 'search', pathMatch: 'full', component: InfrastructuresSearchPage },
    {
        path: 'view',
        pathMatch: 'prefix',
        component: InfrastructuresViewPage,
        canActivate: [IriWithSearchFallbackGuard],
        resolve: { infrastructure: IriResolver },
        runGuardsAndResolvers: 'pathParamsOrQueryParamsChange',
        children: [{ path: ':slug', component: InfrastructuresSarView }],
    },
    {
        path: 'edit',
        pathMatch: 'prefix',
        component: InfrastructuresEditPage,
        canActivate: [IriWithSearchFallbackGuard, AuthenticatedGuard, ContentEditGuard],
        canDeactivate: [CanDeactivateChangesWarning],
        resolve: { infrastructure: IriResolver },
        runGuardsAndResolvers: 'pathParamsOrQueryParamsChange',
        children: [{ path: ':slug', component: InfrastructuresEditPage }],
    },
    {
        path: 'create',
        canActivate: [AuthenticatedGuard, ContentCreateGuard],
        data: { content: 'infrastructures' },
        component: InfrastructuresEditPage,
    },
];

@NgModule({
    declarations: [
        InfrastructuresLandingPage,
        InfrastructuresSearchPage,
        InfrastructuresViewPage,
        InfrastructuresEditPage,
        InfrastructuresForm,
        InfrastructureMarkerColorPipe,
        InfrastructuresSarView,
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(ROUTES),
        SharedModule,
        IsavCommonModule,
        ReactiveFormsModule,
        SearchModule.forFeature('infrastructures', InfrastructuresResourceService),
        ChangesWarningSharedModule,
    ],
})
export class InfrastructuresModule {}
